// Runs the user started in this browser. Persisted so the completion banner
// survives navigation and reloads while the analysis keeps running server-side.
export interface WatchedRun {
  jobId?: string | null;
  shareId: string;
  projectId?: string | null;
  url?: string | null;
  startedAt: number;
}

const KEY = 'eyecaptain.v3.watchedRuns';
const EVENT = 'eyecaptain:v3-watched-runs';

export function getWatchedRuns(): WatchedRun[] {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter((r) => r && typeof r.shareId === 'string') : [];
  } catch {
    return [];
  }
}

function write(runs: WatchedRun[]) {
  try {
    localStorage.setItem(KEY, JSON.stringify(runs));
  } catch {
    /* storage full or unavailable: watching is best-effort */
  }
  window.dispatchEvent(new CustomEvent(EVENT));
}

export function addWatchedRun(run: Omit<WatchedRun, 'startedAt'> & { startedAt?: number }) {
  const runs = getWatchedRuns().filter((r) => r.shareId !== run.shareId);
  runs.push({ ...run, startedAt: run.startedAt ?? Date.now() });
  write(runs.slice(-10));
}

export function removeWatchedRun(shareId: string) {
  write(getWatchedRuns().filter((r) => r.shareId !== shareId));
}

export function subscribeWatchedRuns(cb: () => void) {
  const handler = () => cb();
  window.addEventListener(EVENT, handler);
  window.addEventListener('storage', handler);
  return () => {
    window.removeEventListener(EVENT, handler);
    window.removeEventListener('storage', handler);
  };
}
